import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";


function FormulaChemTopics() {
  return (
    <>

      <AllSubjectTopics subject="chemistry" type="formula" />


    </>
  );
}

export default FormulaChemTopics;